<script>
export default {
  name: "dark-logo",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="237.325"
    height="86.47"
    viewBox="0 0 237.325 86.47"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_1"
          data-name="Rectangle 1"
          width="237.325"
          height="86.47"
          fill="none"
        />
      </clipPath>
    </defs>
    <g id="Group_10236" data-name="Group 10236" transform="translate(0 0)">
      <g id="Group_2" data-name="Group 2" transform="translate(0 0)">
        <g id="Group_1" data-name="Group 1" clip-path="url(#clip-path)">
          <path
            id="Path_1"
            data-name="Path 1"
            d="M55.824,59.082V75.5H53.741V59.082ZM61.585,66.9c0-1.229-.039-2.2-.1-3.18h1.85l.116,1.936h.058a4.236,4.236,0,0,1,3.807-2.2c1.582,0,4.057.973,4.057,5.019V75.5H69.3V68.705c0-1.9-.7-3.5-2.661-3.5a3.027,3.027,0,0,0-2.822,2.2,3.411,3.411,0,0,0-.144.994v7.1H61.585Zm15.689-3.18,2.259,6.6c.388,1.091.685,2.064.943,3.041h.062c.264-.978.594-1.958.964-3.041l2.253-6.6h2.189L81.413,75.5h-2L75.031,63.719Zm17.5,10.364a7.594,7.594,0,0,0,3.189-.6L98.327,75a9.106,9.106,0,0,1-3.84.75c-3.538,0-5.666-2.411-5.666-5.944,0-3.569,2.056-6.357,5.418-6.357,3.756,0,4.738,3.372,4.738,5.539a5.334,5.334,0,0,1-.071,1H90.832C90.873,72.889,92.669,74.083,94.771,74.083Zm2.188-5.63c.021-1.349-.54-3.467-2.888-3.467-2.137,0-3.048,1.977-3.215,3.467Zm6.31,4.862a5.619,5.619,0,0,0,2.775.839c1.529,0,2.238-.77,2.238-1.754,0-1.031-.61-1.57-2.139-2.157-2.08-.77-3.065-1.928-3.06-3.339,0-1.9,1.507-3.454,3.983-3.454a5.477,5.477,0,0,1,2.819.724l-.52,1.557A4.465,4.465,0,0,0,107,65.039c-1.235,0-1.907.729-1.907,1.617,0,.974.677,1.41,2.186,2.008,1.985.757,3.015,1.78,3.021,3.538,0,2.087-1.586,3.549-4.306,3.549a6.448,6.448,0,0,1-3.236-.821Zm14.216-12.987v3.391h3.008v1.622h-3.008v6.347c0,1.467.413,2.3,1.583,2.3a4.1,4.1,0,0,0,1.214-.155l.1,1.627a5.24,5.24,0,0,1-1.871.294,2.894,2.894,0,0,1-2.26-.907,4.578,4.578,0,0,1-.813-3.072V65.341h-1.783V63.719h1.783V60.881Zm7.345,6.571c0-1.229-.04-2.2-.1-3.18h1.819l.11,1.9h.058a3.964,3.964,0,0,1,3.635-2.164,3.394,3.394,0,0,1,3.245,2.361h.048a4.739,4.739,0,0,1,1.3-1.533,3.865,3.865,0,0,1,2.534-.828c1.536,0,3.8,1.013,3.8,5.11V75.5H139.24V68.835c0-2.281-.822-3.631-2.5-3.631a2.741,2.741,0,0,0-2.491,1.927,3.613,3.613,0,0,0-.171,1.074V75.5h-2.044V68.428c0-1.875-.811-3.224-2.393-3.224a2.91,2.91,0,0,0-2.609,2.137,3.451,3.451,0,0,0-.159,1.056v7.1h-2.043Zm26.947,7.184a7.6,7.6,0,0,0,3.19-.6L155.333,75a9.106,9.106,0,0,1-3.84.75c-3.538,0-5.666-2.411-5.666-5.944,0-3.569,2.056-6.357,5.418-6.357,3.756,0,4.738,3.372,4.738,5.539a5.335,5.335,0,0,1-.071,1h-8.074C147.879,72.889,149.675,74.083,151.777,74.083Zm2.188-5.63c.022-1.349-.54-3.467-2.888-3.467-2.137,0-3.048,1.977-3.215,3.467Zm6.607-1.554c0-1.229-.039-2.2-.1-3.18h1.85l.116,1.936h.058a4.234,4.234,0,0,1,3.807-2.2c1.581,0,4.057.973,4.057,5.019V75.5h-2.083V68.705c0-1.9-.7-3.5-2.661-3.5a3.027,3.027,0,0,0-2.822,2.2,3.411,3.411,0,0,0-.144.994v7.1h-2.083Zm17.61-6.571v3.391h3.008v1.622h-3.008v6.347c0,1.467.413,2.3,1.583,2.3a4.1,4.1,0,0,0,1.214-.155l.1,1.627a5.24,5.24,0,0,1-1.871.294,2.894,2.894,0,0,1-2.26-.907,4.578,4.578,0,0,1-.813-3.072V65.341h-1.783V63.719h1.783V60.881Z"
            transform="translate(4.445 4.887)"
            fill="#161615"
          />
          <text
            id="RAK"
            transform="translate(0 39.271)"
            fill="#161615"
            font-size="46"
            font-family="VerminVibes2"
          >
            <tspan x="0" y="0" letter-spacing="0.009em">RA</tspan>
            <tspan y="0">K</tspan>
          </text>
        </g>
      </g>
      <text
        id="EE"
        transform="translate(118.664 39.271)"
        fill="#a27a2b"
        font-size="47"
        font-family="VerminVibes2"
      >
        <tspan x="0" y="0" letter-spacing="0.009em">E</tspan>
        <tspan y="0">E</tspan>
      </text>
      <text
        id="Z"
        transform="translate(197.748 39.271)"
        fill="#161615"
        font-size="47"
        font-family="VerminVibes2"
      >
        <tspan x="0" y="0">Z</tspan>
      </text>
    </g>
  </svg>
</template>